// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b4f1ae3","453":"674d908c","455":"c71fe63c"}[chunkId] + ".chunk.js";
};